import { cn } from '@/utils/cn';

export const Tag = ({ text, onClick }: { text: string; onClick?: () => void }) => {
  return (
    <div
      className={cn(
        'flex flex-row items-center gap-2 bg-base-accent rounded-lg px-2 py-1',
        onClick ? 'cursor-pointer' : 'cursor-default'
      )}
      onClick={onClick}
    >
      <div className="text-sm text-base-primary">{text}</div>
    </div>
  );
};
